import { render } from "./publicationList.vue?vue&type=template&id=b9c68600&scoped=true"
import script from "./publicationList.vue?vue&type=script&lang=js"
export * from "./publicationList.vue?vue&type=script&lang=js"

import "./publicationList.vue?vue&type=style&index=0&id=b9c68600&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c68600"]])

export default __exports__